import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoTrabajoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoTrabajoPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoTrabajo(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoTrabajo', name: 'TipoTrabajo', title: 'Tipo Miembro' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tipoTrabajos: [],
            tipoTrabajo: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoTrabajo() {
            this.tipoTrabajo = {};
            this.$refs['frm-tipoTrabajo'].show();
        },
        showTipoTrabajo(id) {
            this.isLoading=true;
            this.ss.showTipoTrabajo(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoTrabajo = response.data;
                    this.$refs['view-tipoTrabajo'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoTrabajo() {
            this.$refs['frm-tipoTrabajo'].show();
            this.$refs['view-tipoTrabajo'].hide();
        },
        cancelTipoTrabajo() {
            if (this.tipoTrabajo.id) {
                this.$refs['view-tipoTrabajo'].show();
            }
            this.$refs['frm-tipoTrabajo'].hide();
        },
        saveTipoTrabajo() {
            this.ss.storeTipoTrabajo(this.tipoTrabajo).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoTrabajo'].hide();
                    this.$refs['datatable-tipoTrabajo'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoTrabajo() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyTipoTrabajo(this.tipoTrabajo)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoTrabajo'].hide();
                                this.$refs['datatable-tipoTrabajo'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoTrabajo').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoTrabajo(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
